module.exports = __webpack_public_path__ + "assets/img/82.0bd2a64c.png";